import Box from '@/common/components/Box'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import GoBackButton from '@/common/components/GoBackButton'
import Skeleton from '@/common/components/Skeleton'
import { BillDetailsSection } from '@/features/establishments/components/contract/BillDetailsSection'
import { BillDetailsSectionLoadingState } from '@/features/establishments/components/contract/BillDetailsSectionLoadingState'
import { FeeDetailsSection } from '@/features/establishments/components/contract/FeeDetailsSection'
import { FeeDetailsSectionLoadingState } from '@/features/establishments/components/contract/FeeDetailsSectionLoadingState'
import useEstablishmentCompany from '@/features/establishments/hooks/useEstablishmentCompany'
import { useEstablishmentContract } from '@/features/establishments/hooks/useEstablishmentContract'
import { ChevronsRightIcon } from 'lucide-react'
import { useParams } from 'react-router-dom'

const Show = () => {
  const { establishmentId, id: contractId } = useParams()

  const { data: establishment } = useEstablishmentCompany(establishmentId || '')

  const {
    data: contract,
    error: contractError = {} as any,
    refetch: refetchContract,
    isPending: contractIsPending,
  } = useEstablishmentContract({ id: contractId || '' })

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-1 items-center">
          <GoBackButton fallback={`/establishments/${establishmentId}`} searchLastRouteFromFallback />
          <h2 className="text-white-400">{establishment?.general_information?.fantasy_name}</h2>
          <ChevronsRightIcon strokeWidth={1} size={32} className="text-white-400" />
          <h2>Contrato</h2>
        </div>
      </div>

      <ErrorMessageWrapper
        className="h-[calc(100vh-192px)]"
        statusCode={contractError?.status}
        refetchFunction={refetchContract}
      >
        <Box className="flex flex-col gap-6 overflow-y-auto h-[calc(100vh-192px)]">
          {contractIsPending ? (
            <Skeleton width={192} height={28} />
          ) : (
            <p className="font-bold text-lg">
              Contrato <span className="font-light text-sm italic">{contract?.protocol_number}</span>
            </p>
          )}

          {contractIsPending ? <BillDetailsSectionLoadingState /> : <BillDetailsSection contract={contract} />}

          {contractIsPending ? <FeeDetailsSectionLoadingState /> : <FeeDetailsSection contract={contract} />}
        </Box>
      </ErrorMessageWrapper>
    </>
  )
}

export default Show
